import { render, staticRenderFns } from "./FrontMetrics.vue?vue&type=template&id=24cefd39&"
import script from "./FrontMetrics.vue?vue&type=script&lang=js&"
export * from "./FrontMetrics.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports